// extracted by mini-css-extract-plugin
export default {"wrapper":"HWJuh5","factCard":"QIAkTK","desktop":"np_jQ4","mobile":"aOEgfi","icon":"fifA2E"};